// extracted by mini-css-extract-plugin
export default {"settings":"u6new7r3MWINXCZS_tdm","container":"rysz45F1VaXSuTOIuyPe"};